/**
 * ********************************************************************************************************************
 * Responsibility - Displays a single order within an invoice in the form of a table. The architectural design for this
 * component was inspired by AntDesign's Table component. 🐺
 * *********************************************************
 *
 * @format
 */

import {OrderDescriptionColumn} from './table_columns/order_description_column';
import {OrderStatusColumn} from './table_columns/order_status_column';
import {OrderActionColum} from './table_columns/order_action_colum';
import {OrderIdColumn} from './table_columns/order_id_column';
import {ORDER_STATUS_COMPLETE} from 'frontier-constants';
import NumberFormat from 'react-number-format';
import {IfElse} from 'frontier-utilities';
import {Table} from '@sttark/design-system';
import Moment from 'moment';
import React from 'react';

// styles
import './orders_list.scss';

// changing the index of each column will change the order in which the columns are displayed
const getColumns = isExpedite => [
    {
        key: 'order_id',
        title: 'Order ID',
        index: 'order_id'
    },
    {
        key: 'product_type',
        title: 'Type',
        index: 'product_type'
    },
    {
        key: 'status',
        title: 'Status',
        index: 'status'
    },
    {
        key: 'shipping_date',
        title: !isExpedite ? 'Est. Ship Date' : 'Ship Date',
        index: 'shipping_date'
    },
    {
        key: 'qty',
        title: 'Quantity',
        index: 'qty'
    },
    {
        key: 'description',
        title: 'Description',
        index: 'description'
    },
    {
        key: 'action',
        title: '',
        index: 'action'
    }
];

export function ActiveOrdersList({order, ...props}) {
    const {renderData: cart, className = ''} = props;
    const orders = cart.orders;

    const rows = orders.map(order => {
        return {
            order_id: <OrderIdColumn order={order} />,
            product_type: <span>{order.product_type_label}</span>,
            status: <OrderStatusColumn order={order} cart={cart} />,
            shipping_date: (
                <IfElse condition={order.status_id !== ORDER_STATUS_COMPLETE}>
                    <div>{order.ship_due_formatted}</div>
                    <div>{Moment.unix(order.shipping_time).format('MM/DD')}</div>
                </IfElse>
            ),
            qty: (
                <NumberFormat
                    value={order.duplex_aware_total_qty}
                    thousandSeparator={true}
                    displayType="text"
                />
            ),
            description: <OrderDescriptionColumn order={order} />,
            action: <OrderActionColum cart={cart} order={order} />,
            key: order.id
        };
    });

    return (
        <Table
            columns={getColumns(order?.is_expedited)}
            rows={rows}
            className={`${className} single-active-order-10cn`}
        />
    );
}
